export default [
  { to: 'handbok_policys', title: 'Handbok / Policyer' },
  { to: 'administration', title: 'Administration' },
  { to: 'fore_insats', title: 'Före insats' },
  { to: 'under_insats', title: 'Under insats' },
  { to: 'efter_insats', title: 'Efter insats' },
  { to: 'radda_liv', title: 'Rädda liv' },
  { to: 'information', title: 'Information' },
];
